<template>
  <ZigzagServiceLayout
    mainTitle="OtoModelado de Oreja y Rejuvenecimiento del Lóbulo"
    mainDescription="En Diverse Care Now, ofrecemos procedimientos mínimamente invasivos diseñados para remodelar, rejuvenecer y restaurar sus orejas — sin necesidad de cirugía tradicional. Tiempo de recuperación mínimo con atención profesional."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'OTOMODELADO',
          title: 'OtoModelado de Oreja (Remodelación Sin Incisiones)',
          subtitle: 'Remodele y reposicione las orejas prominentes sin cirugía extensa.',
          paragraphs: [
            "El OtoModelado es un procedimiento mínimamente invasivo diseñado para remodelar y reposicionar las orejas prominentes sin necesidad de cirugía extensa. El procedimiento se realiza utilizando suturas internas permanentes que remodelan el cartílago de la oreja y crean un contorno más natural mientras preservan la anatomía de la oreja.",
            "El procedimiento se realiza en el consultorio bajo anestesia local, permitiendo que los pacientes permanezcan despiertos y cómodos durante el tratamiento. Debido a que no se requieren grandes incisiones, la recuperación es típicamente más rápida que con la otoplastia tradicional, con menos hinchazón y tiempo de inactividad mínimo."
          ],
          list: [
            "Técnica mínimamente invasiva",
            "Realizado bajo anestesia local",
            "Suturas internas permanentes para remodelar la oreja",
            "No requiere anestesia general",
            "Cicatrización mínima",
            "Tiempo de recuperación corto",
            "Resultados de apariencia natural"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'REJUVENECIMIENTO',
          title: 'Rejuvenecimiento del Lóbulo con Rellenos Dérmicos',
          subtitle: 'Restaure el volumen y la apariencia juvenil de los lóbulos envejecidos.',
          paragraphs: [
            "A medida que envejecemos, los lóbulos de las orejas pierden naturalmente colágeno, elastina y grasa, causando que se vean más delgados, desinflados o alargados. Esta pérdida de volumen también puede resultar de años de usar aretes pesados.",
            "En Diverse Care Now, utilizamos rellenos dérmicos de ácido hialurónico para restaurar el volumen perdido, mejorar el contorno y rejuvenecer la apariencia de los lóbulos. El tratamiento crea un aspecto más lleno, suave y juvenil mientras proporciona mejor soporte para los aretes."
          ],
          list: [
            "Restaura la pérdida de volumen relacionada con la edad",
            "Mejora la forma y el contorno de los lóbulos",
            "Crea una apariencia más juvenil",
            "Proporciona mejor soporte para los aretes",
            "Procedimiento de consultorio rápido y mínimamente invasivo"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
